module.exports = __webpack_public_path__ + "img/somebodys favorite food.724239ff.png";